import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { professionalRoles, tipologiaPatente } from '../../../../constants';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function TutelaLegaleSummaryCard({ modificaDati, customer, insuranceRequest }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const contraente = customer.gender !== 'G'
    ? `${customer.name} ${customer.surname}`
    : customer.business_name;

  const residenza = `${customer.province.name}, ${customer.province.car_plate_symbol}`;

  return (
    <Card>
      <Header>
        <Title>Tutela Legale</Title>
        {modificaDati && (
          <ModificaButton type="button" onClick={modificaDati}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>{contraente}</CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>{contraente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Residenza</dt>
              <dd>{residenza}</dd>
            </InfoRow>
            {insuranceRequest.tipologia_patente && (
              <InfoRow>
                <dt>Tipologia Patente</dt>
                <dd>
                  {tipologiaPatente.find(
                    (patente) => patente.id === insuranceRequest.tipologia_patente,
                  )?.name || insuranceRequest.tipologia_patente}
                </dd>
              </InfoRow>
            )}
            {insuranceRequest.abilitazione_professionale && (
              <InfoRow>
                <dt>Abilitazione Professionale</dt>
                <dd>{insuranceRequest.abilitazione_professionale === '0' ? 'No' : 'Si'}</dd>
              </InfoRow>
            )}
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
            {insuranceRequest.customer.plate_number && (
              <InfoRow>
                <dt>Targa</dt>
                <dd>{insuranceRequest.customer.plate_number}</dd>
              </InfoRow>
            )}
            {customer.professional_role && (
              <InfoRow>
                <dt>Ruolo Professionale</dt>
                <dd>{professionalRoles.find((role) => role.id === customer.professional_role)?.name}</dd>
              </InfoRow>
            )}
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default TutelaLegaleSummaryCard;
